import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-camps',
  templateUrl: './camps.component.html',
  styleUrls: ['./camps.component.scss']
})
export class CampsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
